<template>
  <div
    id="tour"
    style="position: fixed; z-index: 1000;"
    :style="mobile ? 'bottom: 100px;' : 'bottom: 16px;'"
    :class="mobile ? `${is_large ? 'w-100' : 'w-75'}` : `${is_large ? 'w-50' : 'w-25'}`"
  >
    <v-card
      elevation="8"
      class="pa-4 mx-4 bg-white"
      v-show="is_tour"
    >
      <v-row class="d-flex align-center">
        <v-col cols="5">
          <span class="font-weight-bold text-primary">{{ name }}</span>
        </v-col>

        <v-col cols="2" class="d-flex justify-center">
          <v-btn
            icon
            size="x-small"
            elevation="0"
            id="tour-move"
            class="px-2"
          >
            <img width="24" :src="require('@/assets/drag.svg')" alt="drag">
          </v-btn>
        </v-col>

        <v-col cols="5" class="d-flex justify-end">
          <v-btn
            icon
            size="x-small"
            elevation="0"
            @click="is_large = !is_large"
          >
            <img width="12" :src="is_large ? require('@/assets/exit-full-screen.svg') : require('@/assets/full-screen.svg')" alt="close">
          </v-btn>
          <v-btn
            icon
            size="x-small"
            elevation="0"
            @click="close_tour"
          >
            <img :src="require('@/assets/close-circle.svg')" alt="close">
          </v-btn>
        </v-col>
      </v-row>
      <div class="mt-4" v-show="!loading" v-if="is_tour">
        <video :key="url" controls autoplay muted loop class="w-100" @loadeddata="loading = false">
          <source :src="url" type="video/mp4">
        </video>
      </div>

      <div
        class="d-flex justify-center h-100 align-center my-4"
        v-if="loading"
      >
        <v-progress-circular
            indeterminate
            class="mx-auto"
            color="primary"
        ></v-progress-circular>
      </div>
    </v-card>
  </div>
</template>

<script>
import Videos from "@/mixin/Videos"

export default {
  name: "VTour",
  mixins: [Videos],
  data: () => ({
    is_large: false,
    name: '',
    url: '',
    is_tour: false,
    loading: true,
  }),
  watch: {
    "$route.name" () {
      this.load_tour()
    }
  },
  computed: {
    mobile() {
      return screen.width < 600
    }
  },
  mounted() {
    this.load_tour()
  },
  methods: {
    load_tour() {
      if (localStorage.getItem('tour') == 1 || localStorage.getItem('tour') == null) {
        if (
          this.videos[this.$route.name] &&
          this.videos[this.$route.name][localStorage.getItem('lang') || 'en']
        ) {
          this.name = this.videos[this.$route.name][localStorage.getItem('lang') || 'en'].name || this.$t('factory_setup')
          this.url = this.videos[this.$route.name][localStorage.getItem('lang') || 'en'].url
          if (this.url) {
            this.loading = true
            this.is_tour = true
            this.mouse_tour()
          } else {
            this.is_tour = false
          }
        } else if (
          this.videos[this.$route.name] &&
          this.videos[this.$route.name].en
        ) {
          this.name = this.videos[this.$route.name].en.name || this.$t('factory_setup')
          this.url = this.videos[this.$route.name].en.url
          if (this.url) {
            this.loading = true
            this.is_tour = true
            this.mouse_tour()
          } else {
            this.is_tour = false
          }
        } else {
          this.is_tour = false
        }
      } else {
        this.is_tour = false
      }
    },
    close_tour() {
      localStorage.setItem('tour', 0)
      this.is_tour = false
      this.is_large = false
      this.$parent.$parent.$parent.$refs.appbar.tour = false
    },
    mouse_tour() {
      let tour_move = document.getElementById('tour-move')
      let tour = document.getElementById("tour")
      const mouse_event = function(event) {
        tour.style.position = 'fixed';
        tour.style.zIndex = 1000;

        function moveAt(pageX, pageY) {
          tour.style.left = pageX - tour.offsetWidth / 2 + 'px';
          tour.style.top = pageY - tour_move.clientHeight + 'px';
        }

        if (event.pageX || event.touches) {
          moveAt(event.pageX || event.touches[0].clientX, event.pageY || event.touches[0].clientY);
        }

        function onMouseMove(event) {
          if (event.pageX || event.touches) {
            moveAt(event.pageX || event.touches[0].clientX, event.pageY || event.touches[0].clientY);
          }
        }

        if (event.pageX) {
          document.addEventListener('mousemove', onMouseMove);

          tour_move.onmouseup = function() {
            document.removeEventListener('mousemove', onMouseMove);
            tour_move.onmouseup = null;
          }
        } else {
          return false
        }
      };
      tour_move.onmousedown = mouse_event
      tour_move.ontouchmove = mouse_event
      tour_move.ondragstart = function() {
        return false;
      };
    }
  }
}
</script>
